import { getUniqueId } from '@/utils/misc'

import { sendTrackerGA } from '../gaTracker'
import { sendTrackerSatuEvent } from '../satuTracker'

export const trackClickDashboardItem = ({
  group,
  name,
}: {
  group: string
  name: string
}) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'prioritas',
    eventAction: 'DASHBOARD_LINK_CLICKED',
    eventParams: {
      eventLabel: name,
    },
  })
  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Platform Prioritas',
    activityType: 'DASHBOARD_LINK_CLICKED',
    eventParams: {
      section: group,
      dashboard: name,
    },
  })
}

export const trackClickDashboardGroup = (section: string) => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'prioritas',
    eventAction: 'PLATFORM_LINK_CLICKED',
    eventParams: {
      eventLabel: section,
    },
  })

  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Platform Prioritas',
    activityType: 'PLATFORM_LINK_CLICKED',
    eventParams: {
      section: section,
    },
  })
}

export const trackViewDashboardPrioritas = () => {
  const trackerId = getUniqueId()
  sendTrackerGA({
    id: trackerId,
    eventName: 'prioritas',
    eventAction: 'PAGE_VIEWED',
  })
  sendTrackerSatuEvent({
    id: trackerId,
    pageTitle: 'Platform Prioritas',
    activityType: 'PAGE_VIEWED',
    eventParams: {},
  })
}
